module.exports = __webpack_public_path__ + "img/gnu_gallery8.c6bb0a2f.jpg";